import { CircularProgress } from "@mui/material";
import { CSSProperties } from "@mui/styles";

export function CenteredProgess({ style }: { style?: CSSProperties }) {
    return <CircularProgress sx={{ margin: "5vh auto", display: "block", ...style }} color="primary" />;
}
